<template>
  <div class="lightbox">
    <vue-easy-lightbox
        moveDisabled
        :visible="visible"
        :imgs="imgs"
        :index="index"
        @hide="hide"
    >
        <template v-slot:toolbar>&nbsp;</template>
    </vue-easy-lightbox>
    <button :class="this.className" @click="() => show()">
        <slot></slot>
    </button>
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox';

export default {
  name: 'Lightbox',
  components: {
    VueEasyLightbox
  },
  props: {
    img: {
        type: Array,
        required: true
    },
    className: {
        type: String
    }
  },
  data() {
    return {
      imgs: this.img,
      visible: false,
      index: 0,
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    }
  }
}
</script>